import { store } from "@store/index";
import { open as openSideNavigation } from "@store/features/layout/sideNavigationSlice";
import type { EntitySetupSidebarParams } from "@/components/apps/EntitySetupSidebarHost";

type EntitySetupSidebarCallbacks = {
  /** Optional navigation after choosing "configure manually" */
  onManual?: () => void
}

let callbacks: EntitySetupSidebarCallbacks = {}

export function openEntitySetupSidebar(
  params: EntitySetupSidebarParams,
  nextCallbacks?: EntitySetupSidebarCallbacks,
) {
  callbacks = nextCallbacks ?? {}
  store.dispatch(
    openSideNavigation({
      position: "right",
      schema: "ENTITY_SETUP",
      params,
      props: {
        width: "420px",
        mobileWidth: "100%",
        runHandleClose: true,
      },
    }),
  )
}

export function consumeEntitySetupManualCallback() {
  const cb = callbacks.onManual
  callbacks = { ...callbacks, onManual: undefined }
  cb?.()
}
